import http from '@/core/http'
// eslint-disable-next-line
import { map } from 'lodash'
// eslint-disable-next-line
// import moment from 'moment'


const state = {
  transmissoes: [],
  extrato: [],
  totalItems: 0
}

const actions = {
  obterRelatorioPagamentos: async ({ commit }, payload) => {
    const result = await http.get('financeiro-pagamentos', { params: payload })
    // se for chamar relatorio nao pode jogar dados no store
    if (!payload.relPDF) { commit('LISTA_TRANSMISSOES', result.data.data) }
    return Promise.resolve(result)
  },

  obterExtrato: async ({ commit }, payload) => {
    const result = await http.get('financeiro-pagamentos/extrato', { params: payload })
    // se for chamar relatorio nao pode jogar dados no store
    if (!payload.relPDF) { commit('LISTA_EXTRAO', result.data) }
    return Promise.resolve(result)
  },

  SyncSaldo: async ({ commit }, payload) => {
    const result = await http.post('financeiro-pagamentos/sync-saldo')
    // se for chamar relatorio nao pode jogar dados no store
    if (!payload.relPDF) { commit('LISTA_TRANSMISSOES', result.data.data) }
    return Promise.resolve(result)
  },

  clearItens: ({ commit }) => {
    commit('LIMPAR_ITEM')
  }
}

const mutations = {
  'LISTA_TRANSMISSOES' (state, payload) {
    state.transmissoes = payload
  },
  'LISTA_EXTRAO' (state, payload) {
    state.extrato = payload.data,
    state.totalItems = payload.totalItems
  },
  'LIMPAR_ITEM' (state) {
    state.transmissoes = []
  },
}

const getters = {
  transmissoes: state => state.transmissoes,
  extrato: state => state.extrato,
  totalItems: state => state.totalItems
}

export default { namespaced: true, state, actions, mutations, getters }